import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from 'angularx-social-login';
import { FacebookLoginProvider, GoogleLoginProvider, LinkedInLoginProvider } from 'angularx-social-login';
import { SocialUser } from 'angularx-social-login';
import { Customer } from '../transcation/transcation';
import { CustomerService } from '../transcation/transcation.service';
import { map } from 'rxjs/operators';
// declare $ for Jquery Initialization
declare var $: any;

@Component({
  selector: 'app-transacition',
  templateUrl: './transacition.component.html',
  styleUrls: ['./transacition.component.css']
})
export class TransacitionComponent implements OnInit, AfterViewInit {
  customers: any;
  user: SocialUser;
  loggedIn: boolean;
   constructor(private authService: AuthService, private customerService: CustomerService) { }

   ngOnInit() {
    this.authService.authState.subscribe((user) => {
      this.user = user;
      this.loggedIn = (user != null);
    });
    this.getCustomersList();
  }

  getCustomersList() {
    // Use snapshotChanges().map() to store the key
    this.customerService.getCustomersList().snapshotChanges().pipe(
      map(changes =>
        changes.map(c => ({ key: c.payload.key, ...c.payload.val() }))
      )
    ).subscribe(customers => {
      this.customers = customers;
    });
  }

  deleteCustomers() {
    this.customerService.deleteAll();
  }

  signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  signInWithFB(): void {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }
  signInWithLinkedIn(): void {
    this.authService.signIn(LinkedInLoginProvider.PROVIDER_ID);
  }

  signOut(): void {
    this.authService.signOut();
  }

   ngAfterViewInit () {
     $(document).ready(function() {
       $('.sidenav').sidenav();
     });
     $(document).ready(function() {
       $('select').formSelect();
     });
     $(document).ready(function() {
       $('.datepicker').datepicker();
     });
 }


}
